/**
 * Format the call centre hours plain text to array
 * @param {string} callCentreHours e.g. “callCentreHours”: “Mon – Fri (8am – 8pm EST) and Sat (9am-5pm EST)”
 *                                   or “callCentreHours”: “Mon - Fri 8:00am - 10:30pm AEST, Sat 8:00am - 5:00pm AEST”
 * @returns {Array} ['Mon – Fri (8am – 8pm EST)', 'Sat (9am-5pm EST)']
*/
const formatOpeningHours = function (callCentreHours) {
    if (!callCentreHours) {
        return [];
    }
    let callCentreHoursTemp = `${callCentreHours}`;
    Object.keys(abbreviationSearchMapping).forEach(
        (partten) => {
            // eslint-disable-next-line security/detect-non-literal-regexp
            callCentreHoursTemp = callCentreHoursTemp.replace(new RegExp(partten), abbreviationSearchMapping[partten]);
        }
    );

    let separator;
    if (callCentreHoursTemp.includes(',')) {
        separator = ',';
    } else if (callCentreHoursTemp.includes('and')) {
        separator = 'and';
    } else {
        return [callCentreHoursTemp];
    }

    const split = callCentreHoursTemp.split(separator);
    return split.map((value) => value.trim());
};

export { formatOpeningHours };

const abbreviationSearchMapping = {
    'Mon\\b': 'Monday',
    'Tue\\b': 'Tuesday',
    'Wed\\b': 'Wednesday',
    'Thur\\b': 'Thursday',
    'Thu\\b': 'Thursday',
    'Fri\\b': 'Friday',
    'Sat\\b': 'Saturday',
    'Sun\\b': 'Sunday'
};
